import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';
import { decimalFormatter } from 'Utils/decimalFormatter';
import Icon from 'Components/Icon';
import History from 'Store/history';


const TribunLeaderBoardMiniSuccesModal = props => {

  const closeModel = props.closeModelProp;

  const miniLeaderBoardList = props.miniLeaderBoard?.scores;
  const me = props?.currentUserId;

  const _renderRiseFallIcon = type => {
    switch (type) {
      case 'UP':
        return <Icon iconName="svgUp" />;
      case 'DOWN':
        return <Icon iconName="svgDown" />;
    }
  };

  const _userOnClick = itemID => {
    History.push(`/tribun/profil/${itemID}`);
    closeModel();
  };

  const _renderList = item => {
    return (
      <div className="tribun-mini-leaderboard__list__user" onClick={ () => _userOnClick(item.user.userId) }>
        <div className="tribun-mini-leaderboard__list__user__rank">
          { _renderRiseFallIcon(item.score.change) }
          { item.score.rank === '-' ? '-' : decimalFormatter(item.score.rank) }
        </div>
        <div className="tribun-mini-leaderboard__list__user__avatar">
          <img src={ item.user.picture } alt={ item.user.username } />
        </div>
        <div className="tribun-mini-leaderboard__list__user__name">
          { item.user.username }
        </div>
        <div className="tribun-mini-leaderboard__list__user__score">
          { item.score.totalScore === '-' ? '-' : decimalFormatter(item.score.totalScore) }
          <div className="tribun-mini-leaderboard__list__user__score__text">
            Toplam Skor
          </div>
        </div>
      </div>
    );
  };
  const arena = miniLeaderBoardList?.map(item => {
    return (
      me === item?.user?.userId
        ? <div className="tribun-mini-leaderboard__list__me" key={ item.user.userId }>
          { _renderList(item) }
        </div >
        : <div key={ item.user.userId }>
          { _renderList(item) }
        </div>
    );
  });


  const options = {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'

  };
  const formatter = ms => new Date( ms )
    .toLocaleDateString('tr-TR', options );
  const lastUpdatedDate = props.miniLeaderBoard.timeStamp ? formatter( parseInt( props.miniLeaderBoard.timeStamp, 10)) : null;

  return (
    <Message type="none">

      <div className="tribun-mini-leaderboard">
        <div className="tribun-mini-leaderboard__text">
          <span>{ EnvironmentManager.getMessageText({ key: 'tribün_minisiralama_aciklama' }) }</span>
        </div>
        { lastUpdatedDate  ? <div className="tribun-leaderboard__lastUpdatedDate">
          <span>{ EnvironmentManager.getMessageText({ key: 'title_tribune_leaderboard_update_date' }) + ' : ' +  lastUpdatedDate }</span>
        </div> : null }
        <div className="tribun-mini-leaderboard__list">
          { arena }
        </div>
      </div>

    </Message>
  );
};

TribunLeaderBoardMiniSuccesModal.propTypes = {
  miniLeaderBoard: PropTypes.object,
  currentUserId: PropTypes.number,
  closeModelProp: PropTypes.func

};

export default TribunLeaderBoardMiniSuccesModal;
